import type { CaseCatalogCategory, CaseCatalogResponse, CaseResponse } from '../../../services/generated/Api';
import { clampLanguage } from '../../../stores/languageStore';

export type CatalogCase = CaseResponse;

export type CatalogCategory = Omit<CaseCatalogCategory, 'cases'> & { cases: CatalogCase[] };

export type CaseCatalog = Omit<CaseCatalogResponse, 'general' | 'categories'> & {
  general: CatalogCase[];
  categories: CatalogCategory[];
};

export type CatalogSort = 'top' | 'price-asc' | 'price-desc' | 'new';

export const categoryName = (category: Pick<CatalogCategory, 'name'>, lang: string): string => category.name[clampLanguage(lang)];
